import { FormikProps } from 'formik';
import { Dropdown, ErrorText, Input } from '../../../components/common/Form';
import Button from '../../../components/common/Button';
import { STATES } from '../../../constants/StatesConstants';
import { RestaurantWizardFormValues } from './restaurantWizardSchema';

type AddressFormValues = RestaurantWizardFormValues['address'];
type AddressField = keyof AddressFormValues;
type AddressErrors = Partial<Record<AddressField, string>>;
type AddressTouched = Partial<Record<AddressField, boolean>>;

const REQUIRED_ADDRESS_FIELDS: readonly AddressField[] = ['address1', 'city', 'postCode', 'governingDistrict'];

interface RestaurantLocationPageProps {
  formik: FormikProps<RestaurantWizardFormValues>;
  onNext: () => void;
  onBack: () => void;
}

const RestaurantLocationPage = ({ formik, onNext, onBack }: RestaurantLocationPageProps) => {
  const addressErrors = formik.errors.address as AddressErrors | undefined;
  const addressTouched = formik.touched.address as AddressTouched | undefined;

  const handleNextClicked = () => {
    formik.setTouched({ address: Object.fromEntries(REQUIRED_ADDRESS_FIELDS.map((f) => [f, true])) }, true);
    if (REQUIRED_ADDRESS_FIELDS.every((f) => !!formik.values.address[f] && !addressErrors?.[f])) {
      onNext();
    }
  };

  return (
    <div className="restaurant-location-page">
      <div className="restaurant-wizard-address-inputs">
        <Input
          name="address.address1"
          label="STREET ADDRESS 1"
          className="restaurant-wizard-street-address1-input"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.address.address1}
          touched={addressTouched?.address1}
          error={addressErrors?.address1}
        />
        <Input
          name="address.address2"
          label="STREET ADDRESS 2"
          className="restaurant-wizard-street-address2-input"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.address.address2}
          touched={addressTouched?.address2}
          error={addressErrors?.address2}
        />
      </div>
      <Input
        name="address.city"
        label="CITY"
        className="restaurant-wizard-city-input"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.address.city}
        touched={addressTouched?.city}
        error={addressErrors?.city}
      />
      <div className="restaurant-wizard-state-select">
        <Dropdown
          label="STATE"
          onChange={(value: string) => formik.setFieldValue('address.governingDistrict', value)}
          value={formik.values.address?.governingDistrict}
          values={[{ label: '', value: '' }, ...STATES]}
        />
        {addressTouched?.governingDistrict && <ErrorText error={addressErrors?.governingDistrict} />}
      </div>
      <Input
        name="address.postCode"
        label="ZIP"
        className="restaurant-wizard-zip-code-input"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.address.postCode}
        touched={addressTouched?.postCode}
        error={addressErrors?.postCode}
      />
      <Button className="restaurant-wizard-back-button" onClick={onBack}>
        BACK
      </Button>
      <Button className="restaurant-wizard-next-button" onClick={handleNextClicked}>
        NEXT
      </Button>
    </div>
  );
};

export default RestaurantLocationPage;
